import React from 'react';

const IconUniversal = () => (
    <svg width="20px" height="20px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
        <g fillRule="nonzero" fill="none">
            <path fill="#E7E6E6" d="M7 0h23l13 13v37H7z" />
            <path fill="#9FA0A4" d="M30 0l13 13H30z" />
            <path
                d="M23.37 25.39a3.94 3.94 0 0 0-2.355 5.05l2.156 5.922a3.94 3.94 0 0 0 7.404-2.694l-1.085-2.98a.788.788 0 1 1 1.48-.539l1.085 2.98A5.515 5.515 0 1 1 21.69 36.9l-2.155-5.922a5.515 5.515 0 0 1 3.296-7.07.788.788 0 1 1 .539 1.481zm1.202 3.304a3.94 3.94 0 0 0 2.354-5.05l-2.155-5.923a3.94 3.94 0 1 0-7.404 2.695l1.085 2.98a.788.788 0 1 1-1.481.539l-1.085-2.98a5.515 5.515 0 1 1 10.365-3.772l2.156 5.922a5.515 5.515 0 0 1-3.296 7.07.788.788 0 1 1-.539-1.481z"
                stroke="#979797"
                strokeWidth=".8"
                fill="#979797"
            />
        </g>
    </svg>
);

export default IconUniversal;
